import React, { FC } from 'react';

import { useDayPicker } from 'react-day-picker';
import { MediumHeader } from '@narvar/nth-bit-header';
import dayjs from 'dayjs';
import { useTranslator } from '../utils/translator';

interface CaptionLabelProps {
  displayMonth: Date;
}

const CaptionLabel: FC<CaptionLabelProps> = ({ displayMonth }) => {
  const {
    locale,
    formatters: { formatCaption },
  } = useDayPicker();

  const { t, locale: userLocale } = useTranslator();

  let label = formatCaption(displayMonth, { locale });
  if (userLocale) {
    const tmp = dayjs(displayMonth).format('MMMM YYYY');
    const [monthName, year] = tmp.split(' ');
    const translatedMonthName = t(monthName);
    if (translatedMonthName !== monthName) {
      label = `${translatedMonthName} ${year}`;
    }
  }
  return (
    <MediumHeader aria-live="polite" aria-atomic="true">
      {label}
    </MediumHeader>
  );
};

export default CaptionLabel;
